import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import load1 from '../assets/load1.png';
import load2 from '../assets/load2.png';
import load3 from '../assets/load3.png';
import progress_icon from '../assets/progress_icon.png';
import error_icon from '../assets/error_icon.png';
import axios from 'axios';
import { saveAs } from 'file-saver';

function breakLine(text) {
    var br = React.createElement('br');
    var regex = /(<br \/>)/g;
    return text.split(regex).map(function(line, index) {
        return line.match(regex) ? <br key={"key_" + index} /> : line;
    });
}

function Game() {
    const [loadStep, setLoadStep] = useState(0)
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState('');
    const [uploadedImage, setUploadedImage] = useState('');
    const [randomResult, setRandomResult] = useState(0)
    const [userID, setUserID] = useState('')

    const ages_arr = [5, 24, 30, 10, 18, 15, 21, 36, 42, 3]
    const result_arr = [
        'Дай‑ка угадаем: в школе ты влюблялась исключительно в старшеклассников и заглядывалась на старших братьев своих подружек. Похоже, с ровесниками тебе скучновато, поэтому тебя привлекают более зрелые партнёры.<br /><br />И кажется, подруга, ты уже нашла свою идеальную половинку. Желаем вам вечной любви! 🥰',
        'Кто‑то скажет: «Да он тебе в отцы годится!», но тебе, кажется, наплевать на эти предрассудки. В отношениях со зрелым мужчиной ты наверняка ощущаешь себя нежной принцессой за спиной у сильного дракона.<br /><br />Возможно, иногда вам бывает непросто понимать друг друга, но разве это преграда для настоящей любви? ❤️',
        'Наверняка ваша пара всегда окружена повышенным вниманием: всем безумно интересно, как вы понимаете друг друга, если говорите буквально на разных языках?<br /><br />Но реакция окружающих вас, похоже, совсем не смущает — когда вы вместе, стук ваших сердец заглушает все голоса вокруг. ❤️',
        'Похоже, формула вашей любви проста: один из вас уже точно нагулялся, а другой добавляет веселья и лёгкости в ваш размеренный быт. 🔥<br /><br />Звучит как заявка на долгие и счастливые отношения!',
        'Кажется, ваши отношения похожи на ежедневный краш-тест. Наверняка вы смотрели разные мультики в детстве, слушали разную музыку в студенческие годы, да и в целом вы разные, как лучик с тенью.<br /><br />Зато вы никогда не заскучаете рядом друг с другом. 😉',
        'Похоже, в ваших отношениях ты ощущаешь себя немного старше своего партнёра. Ты очень заботливая, опытная и мудрая, что безумно нравится твоему мужчине, а тебя привлекает его готовность к совместным приключениям.<br /><br />Главное — не перестараться и не превратиться в «мамочку» для своей второй половинки, и тогда всё у вас будет шикарно!',
        'Кажется, вы из разных поколений, и иногда ваша непохожесть даёт о себе знать.<br /><br />Зато вы наверняка постоянно учите друга друга чему‑то новому: сначала обмениваетесь опытом, как правильно убираться, потом объясняете друг другу смысл ваших любимых мемов… 💞',
        'Ты, конечно, слышала, что в обществе неоднозначное отношение к бракам с большой разницей в возрасте, но точно знаешь, что у вас всё будет супер. Мы угадали?<br /><br />Пусть другие перевоспитывают инфантильных мальчиков, а тебе нужен настоящий, психологически зрелый мужчина! 💪🏻',
        'Ого! Кажется, вы очень смелые, если решились на отношения, имея такую психологическую разницу в возрасте!<br /><br />Главное — забудьте про ревность и принимайте друг друга такими, какие вы есть, не сравнивая с предыдущими партнёрами. Держим кулачки за вашу пару. ❤️',
        'Один из вас, возможно, более взрослый, чем другой, но, на самом деле, у вас очень удобная разница в возрасте: по крайней мере, он не понимает твою маму лучше, чем тебя, и сможет поддержать разговор с твоими друзьями. 😉<br /><br />Желаем вам оооооогромного счастья! 🧡'
    ]

    useEffect(() => {
        // window.okAsyncInit = function() {
        //     window.OK.init({
        //         appId: "512002432053",
        //         appKey: "CGDNBKLGDIHBABABA"
        //     });
        //     console.log("OK API initialized");
        // };
        // setTimeout(() => {
        //     // window.okAsyncInit = function() {
        //     //     window.OK.init({
        //     //         appId: "512002432053",
        //     //         appKey: "CGDNBKLGDIHBABABA"
        //     //     });
        //     //     console.log("OK API initialized");
        //     // };
        //     var rParams = window.FAPI.Util.getRequestParameters();
        //     console.log("API Server:", rParams["api_server"]);
        //     console.log("API Connection:", rParams["apiconnection"]);
        //     // const mockParams = {
        //     //     api_server: "https://api.ok.ru/",
        //     //     apiconnection: "0123456789abcdef", // Замените на реальное значение
        //     //     session_key: "-n-53JFBWEUtdXKlR58s3WPbn8FgjK1X9GAKTtHxYoMMUMZoEIQoKmEzRwBKyqcdAaVxHqD5c0Ov3BKDPjv3", // Замените на реальное значение
        //     //     session_secret_key: "699b7cbfaf1dbef53d7054889383846f", // Замените на реальное значение
        //     //     app_key: "CGDNBKLGDIHBABABA" // Замените на ваш app_key
        //     // };
        //
        //     // window.OK.init({
        //     //     appId: "YOUR_APP_ID",
        //     //     appKey: "YOUR_APP_KEY"
        //     // });
        //     // window.FAPI.init(
        //     //     mockParams.api_server,
        //     //     mockParams.apiconnection,
        //     //     function() {
        //     //         console.log("OK API initialized");
        //     //     },
        //     //     function(error) {
        //     //         console.error("Error initializing OK API:", error);
        //     //     }
        //     // );
        // }, 1000);

        let params = new URLSearchParams(document.location.search);
        let value = params.get('logged_user_id');
        setUserID(value)
    }, []);


    const handleFileChange = (event) => {

        const selectedFile = event.target.files[0];


        if (selectedFile) {
            setFileName(selectedFile.name)
            if (selectedFile.size > 5 * 1024 * 1024) {
                setError('Файл должен быть не более 2 МБ');
                setLoadStep(2)
                setFile(null);
            } else if (!['image/jpeg', 'image/png'].includes(selectedFile.type)) {
                setError('Файл должен быть в формате JPG или PNG');
                setLoadStep(2)
                setFile(null);
            } else {
                setError('');
                setFile(selectedFile);
                handleUpload(selectedFile)
                // setTimeout(function (){
                // }, 1000)

            }
        }
    };

    const handleUpload = async (selectedFile) => {
        console.log(file)
        if (!selectedFile) {
            setError('Пожалуйста, выберите файл');
            return;
        }

        setFileName(selectedFile.name)
        setLoadStep(1)
        const formData = new FormData();
        formData.append('photo', selectedFile);


        try {

            const newImage = await axios.post('https://flami-dev.ru/upload/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {

                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setProgress(percentCompleted);

                }
            });
            setLoadStep(3)
            setRandomResult(Math.round(Math.random() * 9))
            setUploadedImage(newImage.data)
            setProgress(0);
            setFile(null);

            sendReq()

        } catch (error) {
            setError('Ошибка при загрузке файла');
            console.error('Ошибка загрузки:', error);
        }
    };

    const handleSetAvatar = async () => {
        const photoUrl = uploadedImage; // Замените на реальный URL фото


        try {
            // Загрузка фото
            const response = await axios.get(photoUrl, { responseType: 'blob' });
            const photoBlob = response.data;
            // Получение URL для загрузки

            const uploadUrlResponse = await window.fapiClient.call({
                method: "photos.getUploadUrl",
                format: "json"
            });

            // console.log(window.fapiClient)
            if (uploadUrlResponse.error) {
                throw new Error(uploadUrlResponse.error_msg);
            }

            // Загрузка фото на сервер OK
            const formData = new FormData();
            formData.append('photo', photoBlob, 'avatar.jpg');


            // const uploadResponse = await axios.post(uploadUrlResponse.upload_url, formData, {
            //     onUploadProgress: (progressEvent) => {
            //         const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            //         setProgress(percentCompleted);
            //     }
            // });
            //
            // // Установка фото как аватара
            // const setAvatarResponse = await window.fapiClient.call({
            //     method: "photos.setAvatar",
            //     photo_id: uploadResponse.data.photo_id,
            //     format: "json"
            // });
            //
            // if (setAvatarResponse.error) {
            //     throw new Error(setAvatarResponse.error_msg);
            // }
            //
            // alert('Аватар успешно обновлен!');
            // setProgress(0);
        } catch (error) {
            // setError('Ошибка при обновлении аватара: ' + error.message);
            console.error('Ошибка:', error.message);
        }
    };

    // const handleDownload = (uploadedImageURL) => {
    //     const url = uploadedImageURL;
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.download = 'prvvvv.txt'; // Имя файла для скачивания
    //     link.click();
    //     link.remove(); // Удалить ссылку после скачивания
    //
    //
    // };


    const sendReq = async () => {
        const url = 'https://zhduli.tvlist.fun/ajax/addokuser.php'
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({userid: userID}),
            headers: {'content-type': 'application/json'},
            mode: 'no-cors',
        };
        try {
            await fetch(url, requestOptions);
        }catch (e){ /* empty */ }
    }


    const handleDownload = (url) => {
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                saveAs(blob, 'rama.png'); // Имя файла можно изменить на динамическое
            })
            .catch(error => console.error('Error downloading file:', error));
    };

    return (
        <div className="game">
            <div className="loaderLayer">
                {loadStep === 0 ?
                <img src={load1} className="loadIcon" alt=""/>
                    : null }
                {loadStep === 1 ?
                <img src={load2} className="loadIcon rotate" alt=""/>
                    : null }

                {loadStep === 2 ?
                <img src={load3} className="loadIcon" alt=""/>
                    : null }
                {loadStep === 3 ?
                <img src={uploadedImage} className="uploadedImage" alt=""/>
                    : null }
            </div>
            {loadStep < 3 ?
            <div className="gameContent">
                <div className="homeTitle">
                    Загрузи ваше<br/>
                    совместное фото
                </div>
                <p>Загрузи любимый снимок с твоей второй половинкой,<br/> чтобы узнать результат</p>
                {loadStep === 1 && (
                    <div className="progress-bar">
                        <img src={progress_icon} alt=""/>
                        <div className="progressBarLineC">
                            <p>Загрузка <span style={{color:'#0373B4'}}>“{fileName}”</span></p>
                            <div className="progressBarLine">
                                <div className="progress" style={{width: `${progress}%`}}></div>
                            </div>
                            <p style={{opacity: 0.4}}>{progress}% загружено...</p>
                        </div>
                    </div>
                )}
                {loadStep === 2 && (
                    <div className="progress-bar">
                        <img src={error_icon} alt=""/>
                        <div className="progressBarLineC">
                            <p>Ошибка загрузки <span style={{color:'#0373B4'}}>“{fileName}”</span></p>
                        </div>
                    </div>
                )}

                <p>Загрузите квадратное фото формата png или jpeg до 5 Мб</p>

                <div className="linkBtn" style={loadStep === 1 ? {opacity: 0.4, pointerEvents: "none"} : {opacity: 1}}>загрузить фото<input type="file" onChange={handleFileChange} accept=".jpg,.jpeg,.png"/></div>
            </div>
            :
            <div className="gameContent">
                <div className="homeTitle">
                    Психологическая разница<br/> в возрасте: {ages_arr[randomResult]} лет
                </div>
                <p>{breakLine(result_arr[randomResult])}</p>
                <div className="gameDoubleButtons">
                    <Link className="linkBtn" target='_blank' to={'https://ok.ru/app/decoratephoto/?custom_args=%7B%22sectionId%22%3A%22partners%22%2C%22frameId%22%3A%2214327%22%7D'}>Установить рамку</Link>
                    <Link className="linkBtn" target='_blank' to={uploadedImage}>скачать</Link>
                </div>
                <div className="linkBtn"
                     style={loadStep === 1 ? {opacity: 0.4, pointerEvents: "none"} : {opacity: 1}}>загрузить фото<input
                    type="file" onChange={handleFileChange} accept=".jpg,.jpeg,.png"/></div>
            </div>

            }
        </div>
    );
}

export default Game;